<template>
    <div id="app">
      <Gallery :translations="translations" :config="config"/>
    </div>
</template>

<script>
import Gallery from './components/Gallery'
export default {
  name: 'App',
  components: {
    Gallery
  },
  computed: {
    translations() {
      return window.galleryConfig ? window.galleryConfig.translations : {};
    },
    config() {
      return window.galleryConfig ? window.galleryConfig.config : {};
    },
  },
};
</script>
